import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { IntencaoDepositoFilterOptions } from '../shared/helpers/models/intencao-deposito-filter-options';
import { IntencaoDepositoPaged } from '../models/intencao-deposito-paged';
import { TipoDeposito } from '../models/tipo-deposito';
import { IntencaoDepositoDetalhes } from '../models/intencao-deposito-detalhes';
import { GerarBoletoCadastro } from '../models/gerar-boleto-cadastro';
import { BoletoInfo } from '../models/boleto-info';
import { ReciboIntencaoDeposito } from '../models/recibo-intencao-deposito';
import { AuthenticationService } from './authentication.service';
import { Auth } from '../models/auth';
import { DepositosRequest, GenerateDepositRequest, SaveDepositRequest } from '../models/request/depositos-request';
import { GenerateDepositResponse } from '../models/response/deposit-response';

@Injectable({
    providedIn: 'root'
})
export class DepositoService {

    // Intenção de Depósito
    API: string = environment.API + 'Portal/depositos';
    private URL = environment.GATEWAY + 'deposits';
    // private currentUser: Auth;

    constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
        // this.currentUser = this.authenticationService.currentUserValue;
    }


    getAllPaged(cedenteGuid: string, gestorGuid: string, offset: number, limit: number, filters: IntencaoDepositoFilterOptions, filterObject: DepositosRequest): Observable<ResponseBase<IntencaoDepositoPaged>> {

        // parametros
        let params = new HttpParams();
        // opções de pesquisa
        params = params.append('q', filters.q);

        // paginação
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.post<ResponseBase<IntencaoDepositoPaged>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, filterObject, { params });
    }

    getTiposDeposito(): Observable<ResponseBase<TipoDeposito[]>> {
        return this.http.get<ResponseBase<TipoDeposito[]>>(`${this.API}/tipos`);
    }

    getDetails(intencaoDepositoGuid: string, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<IntencaoDepositoDetalhes>> {
        return this.http.get<ResponseBase<IntencaoDepositoDetalhes>>(`${this.API}/${intencaoDepositoGuid}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
    }

    generateBoleto(intencaoDepositoGuid: string, gerarBoletoCadastro: GerarBoletoCadastro, cedenteGuid: string): Observable<ResponseBase<BoletoInfo>> {
        return this.http.post<ResponseBase<BoletoInfo>>(`${this.API}/${intencaoDepositoGuid}/cedente/${cedenteGuid}/gerar-boleto`, gerarBoletoCadastro);
    }

    getRecibo(intencaoDepositoGuid): Observable<ResponseBase<ReciboIntencaoDeposito>> {
        return this.http.get<ResponseBase<ReciboIntencaoDeposito>>(`${this.API}/${intencaoDepositoGuid}/recibo`);
    }

    getRPS(depositoId: number): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.URL}/rps/${depositoId}`);
    }

    getNfs(cedenteGuid: string, depositoGuid: string): Observable<ResponseBase<any>> {

        let params = new HttpParams();
        params = params.append(`assignorGuid`, cedenteGuid);

        return this.http.get<ResponseBase<any>>(`${this.URL}/${depositoGuid}/download/nfs`, { params: params });
    }

    generateDeposit(assignorGuid: string, managerGuid: string, generateDeposit: GenerateDepositRequest): Observable<ResponseBase<GenerateDepositResponse>> {
        return this.http.post<ResponseBase<GenerateDepositResponse>>(`${this.URL}/assignors/${assignorGuid}/managers/${managerGuid}/generate`, generateDeposit);
    }

    saveDeposit(assignorGuid: string, saveDeposit: SaveDepositRequest): Observable<ResponseBase<GenerateDepositResponse>> {

        let params = new HttpParams();
        params = params.append(`assignorGuid`, assignorGuid);

        return this.http.post<ResponseBase<GenerateDepositResponse>>(`${this.URL}/save`, saveDeposit, { params });
    }

}
